import React, { useState , useEffect } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import moment from "moment";
import './datePickerStyle.css'
import toast from "react-hot-toast";

const DatePickerInput = ({ handleFormatted, setSelectedDate, tripType  , setCheck}) => {

    /***********************use context for the show Alerts message ***********/
    let dbData = JSON.parse(localStorage.getItem('cab_listing')) || {};
    const [startDate, setStartDate] = useState(null);

    useEffect(() => {

        if(startDate){
            handleFormatted({ 'pickup_date': startDate });
        }

    } , [startDate])
    
    useEffect(() => {

        let defaultDate;

        const getDefaultDate = () => {
            if (!dbData.pickup_date) return new Date();
            
            const storedDate = new Date(dbData.pickup_date);
            const today = new Date();
            
            // Compare dates without time components
            const storedDateAtMidnight = new Date(storedDate);
            storedDateAtMidnight.setHours(0, 0, 0, 0);
            
            const todayAtMidnight = new Date(today);
            todayAtMidnight.setHours(0, 0, 0, 0);
          
            return storedDateAtMidnight < todayAtMidnight ? todayAtMidnight : storedDate;
        };
          

        if(dbData.trip_type === tripType){
            defaultDate = dbData.pickup_date ? getDefaultDate(): new Date();
            handleFormatted({ 'pickup_date': dbData.pickup_date ? getDefaultDate(): new Date() })

        }else {
            defaultDate = new Date();
            handleFormatted({ 'pickup_date': new Date() });
        }
        setStartDate(defaultDate);
        setSelectedDate(defaultDate);
        // handleFormatted({ 'pickup_date': defaultDate })
        setCheck(false);
    }, []);
    // Date handle functions
    const DateHandler = (date) => {

        setSelectedDate(date)
        setCheck(true);
        if (!moment(date).isSameOrAfter(moment() , 'day')) {
            toast.error('Please select the further Date')
            setStartDate(null);
            return;
        }

        setStartDate(date)
        // set the handle functions to date;
        handleFormatted({ 'pickup_date': date })
    }

    return (
        <>
            <Form.Group className="w15 position-relative" controlId="">
                <Form.Label>When</Form.Label>
                <DateRangeIcon />
                <DatePicker
                    className="datePickerStyling"
                    selected={startDate || new Date()}
                    placeholderText="Select Date"
                    value={startDate || new Date()}
                    onChange={(date) => DateHandler(date)}
                    minDate={new Date()}
                    dateFormat="dd/MM/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                />
            </Form.Group>
        </>
    )
}


export default DatePickerInput